<template lang="pug">
nav.fixed-top.top-header(:class="{ expand: hambergurStatus }")
  .container-fluid
    .menu_content
      router-link.nav-link(to="/" @click.native="toNext")
        img.header-logo.d-sm-none(src="@/assets/img/logo/logo_xs.svg")
        img.header-logo.d-none.d-sm-inline-block(
          src="@/assets/img/logo/logo.svg"
        )
      .login_area.d-flex.align-items-center
        .nav-link.apply(@click="toEnroll") 立刻報名
        .to_login(@click="toLogin")
          span
            font-awesome-icon.right_arrow(:icon="['fas', 'user-alt']")
          span(v-if="!this.$store.state.user.accessToken")
            | 登入會員
          span(v-else)
            | 會員中心
        .hambergur_container.d-md-none(@click="hambergurClick")
          .hambergur_line
    .menu.float-none.float-md-right
      ul.main_links
        li
          router-link.nav-link(
            to="/news",
            :class="{ btn_selected: $route.name == 'News' || $route.name == 'NewsDetail' }",
            @click.native="toNext"
          ) 最新消息
        li
          router-link.nav-link(
            to="/course_intro",
            :class="{ btn_selected: $route.name == 'CourseIntro' || $route.name == 'CourseIntroDetail' }",
            @click.native="toNext"
          ) 課程介紹
        li.multiple(
          v-for="(program, index) in programList",
          v-if="program.is_visible && program.type == 'TYPE_NORMAL'"
        )
          router-link.nav-link(
            :to="{ path: '/course_info', query: { id: program.id } }",
            :class="{ btn_selected: $route.query.id == program.id && ($route.name == 'CourseInfo' || $route.name == 'Locations') }",
            @click.native="toNext"
          ) {{ program.name }}
          ul.sub_menu.normal
            li 
              router-link.sub_item(
                :to="{ path: '/course_info', query: { id: program.id } }",
                :class="{ btn_selected: $route.query.id == program.id && $route.name == 'CourseInfo' }",
                @click.native="toNext"
              ) 課程資訊
            li 
              router-link.sub_item(
                :to="{ path: '/locations', query: { id: program.id } }",
                :class="{ btn_selected: $route.query.id == program.id && $route.name == 'Locations' }",
                @click.native="toNext"
              ) 課程地點
        li(
          v-for="(program, index) in programList",
          v-if="program.is_visible && program.type == 'TYPE_CAMP'"
        )
          router-link.nav-link(
            :to="{ path: '/training_events', query: { id: program.id } }",
            :class="{ btn_selected: $route.query.id == program.id && $route.name == 'TrainingEvents' }",
            @click.native="toNext"
          ) {{ program.name }}
        li
          router-link.nav-link(
            to="/coaches",
            :class="{ btn_selected: $route.name == 'Coaches' || $route.name == 'CoachesDetail' }",
            @click.native="toNext"
          ) 教練資訊
        li(
          v-for="(announcement, index) in announcementList",
          v-if="announcement.is_active"
        )
          router-link.nav-link(
            :to="{ path: '/announcements', query: { id: announcement.id } }",
            :class="{ btn_selected: $route.query.id == announcement.id && $route.name == 'Announcements' }",
            @click.native="toNext"
          ) {{ announcement.name }}
        li
          router-link.nav-link(
            to="/games",
            :class="{ btn_selected: $route.name == 'Games' }",
            @click.native="toNext"
          ) 聯賽數據
        li
          router-link.nav-link(
            to="/contacts",
            :class="{ btn_selected: $route.name == 'Contacts' }",
            @click.native="toNext"
          ) 關於我們
</template>

<script>
import "@/assets/style/main.scss";
import { mapActions } from "vuex";
import { getProgramList } from "@/api/program";
import { getAnnouncementList } from "@/api/web_content";

export default {
  name: "Navigation",
  data() {
    return {
      hambergurStatus: false,
      programList: [],
      announcementList: [],
    };
  },
  created() {
    this.getProgramList();
    this.getAnnouncementList();
  },
  methods: {
    ...mapActions("user", ["logout"]),
    hambergurClick() {
      this.hambergurStatus = !this.hambergurStatus;
      if (this.hambergurStatus) {
        document.body.classList.add("no-scroll");
        document.documentElement.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
        document.documentElement.classList.remove("no-scroll");
      }
    },
    toNext() {
      this.hambergurStatus = false;
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");
    },
    toLogin() {
      this.hambergurStatus = false;
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");

      if (!this.$store.state.user.accessToken) {
        this.$emit("openLoginDialog");
      } else {
        this.$router.push({ name: "MemberCenter" });
      }
    },
    toEnroll() {
      this.hambergurStatus = false;
      document.body.classList.remove("no-scroll");
      document.documentElement.classList.remove("no-scroll");

      this.$router.push({ name: "Enroll" });
    },
    getProgramList() {
      getProgramList().then((response) => {
        this.programList = response.data;
      });
    },
    getAnnouncementList() {
      getAnnouncementList().then((response) => {
        this.announcementList = response.data;
        console.log("this.announcementList=", this.announcementList);
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/navigation";
</style>
